const API_URL = process.env.REACT_APP_API_URL || '';

let saveTimeout = null;

export async function loadData() {
  try {
    const res = await fetch(`${API_URL}/api/data`, { credentials: 'include' });
    if (res.status === 401) return null;
    if (res.ok) {
      const data = await res.json();
      return data;
    }
  } catch (e) {
    console.error('Failed to load data from server:', e);
  }
  return null;
}

export function saveData(data) {
  if (saveTimeout) clearTimeout(saveTimeout);
  saveTimeout = setTimeout(async () => {
    try {
      await fetch(`${API_URL}/api/data`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
        credentials: 'include',
      });
    } catch (e) {
      console.error('Failed to save data to server:', e);
    }
  }, 300);
}

export async function googleSignIn(code) {
  const res = await fetch(`${API_URL}/api/auth/google`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code }),
    credentials: 'include',
  });
  return await res.json();
}

export async function checkAuth() {
  try {
    const res = await fetch(`${API_URL}/api/auth/me`, { credentials: 'include' });
    if (res.ok) return await res.json();
  } catch (e) {
    console.error('Failed to check auth:', e);
  }
  return { user: null };
}

export async function signOut() {
  await fetch(`${API_URL}/api/auth/logout`, {
    method: 'POST',
    credentials: 'include',
  });
}

export async function fetchAllowedEmails() {
  const res = await fetch(`${API_URL}/api/auth/users`, { credentials: 'include' });
  if (!res.ok) return [];
  const data = await res.json();
  return data.emails || [];
}

export async function fetchFlightStatus(flightNumber, date) {
  let url = `${API_URL}/api/flight-status?flight=${encodeURIComponent(flightNumber)}`;
  if (date) url += `&date=${encodeURIComponent(date)}`;
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to fetch flight status');
  }
  return await res.json();
}

export async function fetchCalendarEvents() {
  const res = await fetch(`${API_URL}/api/calendar`, { credentials: 'include' });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to fetch calendar events');
  }
  const data = await res.json();
  return data.events || [];
}
